import { Pipe, PipeTransform } from '@angular/core';
/**
 * Transform the State of the CardsFilter based on the Type
 */
@Pipe({
  name: 'translateFilterCard'
})
export class TranslateFilterCardPipe implements PipeTransform {
/**
 * Transform the state based on the Type
 * @param value 
 * @param type 
 * @returns 
 */
  transform(value: string, type: String): string {
    if (type == 'filterState') {
      switch (value) {
        case 'CREATED':
          return "Erstellt";
        case 'AVAILABLE':
          return "Verfügbar";
        case 'REQUESTED':
          return "Angefordert";
        case 'ASSIGNED':
          return "Zugeordnet";
        case 'ACTIVE':
          return "Aktiv";
        case 'CLOSE_REQUEST':
          return "Sperrung beantrag";
        case 'CLOSED':
          return "Gesperrt";
        default:
          return value;
      }
    }
  }
}
